import MarketingEventService from '@/api/services/MarketingEventService';

export default class SedMarketingEventService extends MarketingEventService {
  static of(): SedMarketingEventService {
    return new SedMarketingEventService();
  }

  viewPaymentPage = (): void => {
    this.handlers.forEach(handler => {
      handler.trackEvent(
        "sed_view_payment_page",
        null
      );
    });
  }
}
